export const hasNextPage = (
  totalPages: bigint | undefined,
  lastPageParam: number,
) => {
  if (Number(totalPages) === lastPageParam) {
    return null;
  }
  return lastPageParam + 1;
};
